/**
 * Revisions Service
 * Pure async fetcher for admin revision history by date
 */

import { apiClient } from '../apiClient';
import { apiPath } from '../apiPath';
import { RevisionItem, RevisionsResponse } from '../types/revisions';

/**
 * Fetches revision history for appointments on a given date.
 * @param date - Date in YYYY-MM-DD format
 * @returns Array of revision items
 */
export async function fetchRevisionsByDate(date: string): Promise<RevisionItem[]> {
    const { data } = await apiClient.get<RevisionsResponse>(
        apiPath('/admin-revisions/by-date'),
        {
            params: { date },
            withCredentials: true,
        }
    );
    return data.data;
}
